module.exports = __webpack_public_path__ + "static/media/shopping_miniatura.d44a3d37.jpg";